<template>
  <div class="p-3 w-100 h-100 p-relative d-flex flex-column">
    <div class="flex masonry-openended">
      <div
        v-masonry
        transition-duration="0.3s"
        item-selector=".item"
        class="masonry-content"
      >
        <div
          class="item"
          v-for="(team, index) in teams.filter((t) => t.visible === true)"
          :key="index"
        >
          <div class="body-content" :style="{ borderColor: getColor(team), 'background-color': _gameLobbyBg()}">
            <div>{{ team.name }}</div>
            <div class="team-member" v-if="team.teamShow && team.teamShow.length">
              <div
                class="badge badge-pill badge-primary member horizontal layout center"
                :style="{ 'background-color': getColor(team)}"
                v-for="(audience, indexMember) in team.teamShow"
                :key="indexMember"
                v-show="!audience.offline"
              >
                <span v-if="indexMember < 10">
                  <span>{{ audience.audienceEmoji }}</span>
                  <span class="font-weight-bold">
                    {{ audience.audienceName | profanity }}
                  </span>
                </span>
                <span v-if="indexMember === 10">
                  <span class="font-weight-bold">+{{ team.teamCount - 10 }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="!isBackstage && $store.state.presentation.teamCount < 500">
        <div class="add-team" @click="addNewTeam()">
          <i class="fas fa-plus" />
          <span>
            {{ $t('addTeam') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import Util from '@/util'
import EventBus from '@/eventBus'

// api
import PresentationApi from '@/api/presentation'

export default {
  data() {
    return {
      teams: [],
      limit: 200,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      filteringProfanity: (state) => state.presentation.filteringProfanity,
    }),
  },
  mounted() {
    this.$store.state.presentation.teamData.forEach((item) => {
      if (!item.teams) item.teams = []
    })
    this.teams = this.$store.state.presentation.teamData
    setTimeout(() => {
      this._renderTeamMember()
    }, 200)

    EventBus.$on('gamelobby-quiz-team', () => {
      this._renderTeamMember()
    })
    EventBus.$on('gamelobby-leave-team', (doc) => {
      this._leaveTeam(doc)
      this._countTeamActive()
    })
  },
  destroyed() {
    EventBus.$off('gamelobby-quiz-team')
    EventBus.$off('gamelobby-leave-team')
  },
  methods: {
    getTeamMemberLimit() {
      this.teams.forEach((item) => {
        let teamCount = 0
        const teams = []
        if (!item.teams) item.teams = []
        item.teams.forEach((member) => {
          if (!member.offline) {
            teamCount++
            if (teams.length < 11) {
              teams.push(member)
            }
          }
        })
        item.teamCount = teamCount
        item.teamShow = teams
      })
    },
    getColor(team) {
      return team.color || Util.getAhaColor(team.id)
    },
    _gameLobbyBg() {
      const color = Util.hexToRgba(this.$store.state.slideActive.baseColour)
      return Util.changeRgbaColor(color, 0.6)
    },
    _countTeamActive() {
      let count = 0
      this.teams.forEach((item) => {
        if (!item.teams) item.teams = []
        if (item.visible && item.teams.length) {
          for (let i = 0; i < item.teams.length; i++) {
            if (!item.teams[i].offline) {
              count++
              break
            }
          }
        }
      })
      this.$store.dispatch('updatePresentation', { teamActive: count })
    },
    _leaveTeam(doc) {
      this.teams.forEach((item) => {
        if (!item.teams) item.teams = []
        const index = item.teams.findIndex((member) => {
          return member.audience === doc.a
        })
        if (index !== -1) {
          item.teams.splice(index, 1)
        }
      })
      this.teams.push()
      setTimeout(() => {
        this.$redrawVueMasonry()
      }, 200)
      this._countTeamActive()
    },
    _renderTeamMember: _.debounce(function () {
      this.teams.forEach((item) => {
        if (!item.teams) item.teams = []
      })

      Object.keys(this.$store.state.audiences).forEach((key) => {
        const indexTeam = this.teams.findIndex((item) => {
          return item.id == this.$store.state.audiences[key].audienceTeam
        })

        if (indexTeam !== -1) {
          const indexMember = this.teams[indexTeam].teams.findIndex((member) => {
            return (
              member.audience == this.$store.state.audiences[key].audience
            )
          })

          if (indexMember === -1) {
            if (this.teams[indexTeam].teams.length < this.limit) {
              this.teams[indexTeam].teams.push(this.$store.state.audiences[key])
            }
          } else {
            this.teams[indexTeam].teams[
              indexMember
            ] = this.$store.state.audiences[key]
          }
        }
      })
      this.getTeamMemberLimit()
      this.teams.push()
      setTimeout(() => {
        this.$redrawVueMasonry()
        this._countTeamActive()
      }, 1)
    }, 500),
    async addNewTeam() {
      const activeTeams = this.$store.state.presentation.teamData
        .filter((team) => team.visible === true)
      const teamCount = activeTeams.length + 1
      if (teamCount > 500) {
        return
      }

      // Increase team number
      const teamMap = {}
      this.$store.state.presentation.teamData.forEach((t) => { teamMap[t.id] = t })

      const hidden = this.$store.state.presentation.teamData
        .filter((team) => team.visible === false)
      const activeNames = new Set(activeTeams
        .map((team) => team.name && team.name.trim().toLowerCase()))

      let newTeam

      if (hidden.length) {
        [newTeam] = hidden
        newTeam.visible = true
      } else {
        const maxId = activeTeams.map((team) => team.id).reduce((a, b) => Math.max(a, b), 0)
        const id = maxId + 1
        newTeam = {
          id,
          name: `Team ${id}`,
          visible: true,
        }
        teamMap[id] = newTeam
      }

      let newName = newTeam.name.trim().toLowerCase()
      if (activeNames.has(newName)) {
        let count = 1
        while (activeNames.has(newName)) {
          newTeam.name = `Team ${count}`
          newName = newTeam.name.trim().toLowerCase()
          count += 1
        }
      }

      this.$store.state.presentation.teamCount = teamCount
      this.$store.state.presentation.teamData = Object.values(teamMap)
        .sort((a, b) => a.id - b.id)

      this.$store.state.presentation.teamData.push()
      this.teams = this.$store.state.presentation.teamData
      this.getTeamMemberLimit()
      // Redraw VueMasonry
      setTimeout(() => {
        this.$redrawVueMasonry()
      }, 0)

      this.$store.dispatch('setSyncPresentation', 1)

      // Update presentation
      const payload = {
        teamCount,
        teamData: [],
        uniqueAccessCode: this.$store.state.presentation.uniqueAccessCode,
      }

      payload.teamData = this.teams.map((te) => {
        return {
          name: te.name,
          id: te.id,
          color: te.color,
          visible: te.visible,
        }
      })
      try {
        const presentationId = this.$store.state.presentation.id
        await PresentationApi.updatePresentationByPresentationId(presentationId, payload)
        this.$store.dispatch('setSyncPresentation', 2)
        Util.mixpanelTracking('Slide', 'Edit setting', 'Presenter quiz team add new team done')
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)

        Util.mixpanelTracking('Slide', 'Edit setting', 'Presenter quiz team add new team fail')
        throw error
      }
      this._countTeamActive()
    },
    getNameTeam(name) {
      const index = this.$store.state.presentation.teamData.findIndex((item) => {
        return item.name.toLowerCase() === name.toLowerCase()
      })
      if (index !== -1) return `Team ${index + 1}`
      return name
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.add-team {
  text-align: center;
  padding: 20px;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  margin: 0 auto;
}

.masonry-openended {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .masonry-content {
    width: 100%;
    height: 100%;
  }

  .item {
    padding: 10px;
    width: calc(100% / 3);
    z-index: 9;

    .body-content {
      border: 2px solid green;
      border-radius: 8px;
      transition: all 0.25s;
      cursor: pointer;
      white-space: pre-line;
      word-break: break-word;
      position: relative;
      padding: 10px 16px;
      &:hover {
        transform: scale(1.05);
        .remove-icon {
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
      }
      .member {
        background-color: #000;
        color: #fff;
        padding: 6px 12px 4px 10px;
        margin-right: 4px;
        display: inline-block;
        margin-bottom: 4px;
      }
    }
    &:hover {
      z-index: 20;
    }
  }
}
</style>
